import { TextBlockParser as o } from "./text-block-parser.js";
import { BLOCK_TYPES as i, DEFAULT_ALIGNMENT as a } from "./constants.js";
import { d as r } from "./_virtual/index.js";
import { getResponsiveClasses as l } from "./utils/tables.js";
class B {
  constructor(e, t) {
    this.config = t, this.documentBuilder = e, this.schema = e.schema, this.textBlockParser = new o(e, t), this.customBlockHandlers = /* @__PURE__ */ new Map();
    for (const s of t.customBlockHandlers ?? [])
      this.customBlockHandlers.set(s.type, s);
  }
  schema;
  documentBuilder;
  textBlockParser;
  customBlockHandlers;
  handle(e, t) {
    const s = this.customBlockHandlers.get(e.type);
    if (s) {
      s.parse(e, this);
      return;
    }
    switch (e.type) {
      case i.ORDERED_NESTED_LIST:
      case i.UNORDERED_NESTED_LIST:
        this.nestedList(e);
        break;
      case i.PARAGRAPH:
      case i.ORDERED_LIST:
      case i.UNORDERED_LIST:
      case i.HEADING:
      case i.SUBHEADING:
      case i.SUBHEADING3:
      case i.SUBHEADING4:
      case i.SMALL:
        this.textBlockParser.handle(e, t);
        break;
      case i.CODE:
        this.schema.nodes.codeBlock ? this.textBlockParser.handle(e, t) : this.handleFallback(e);
        break;
      case i.HTML:
        this.html(e);
        break;
      case i.HORIZONTAL_RULE:
        this.horizontalRule(e);
        break;
      case i.IMAGE:
        this.image(e);
        break;
      case i.IMAGE_TEXT:
        this.imageText(e);
        break;
      case i.VIDEO:
        this.video(e);
        break;
      case i.VIDEO_FILE:
        this.videoFile(e);
        break;
      case i.AUDIO_FILE:
        this.audioFile(e);
        break;
      case i.BUTTON:
        this.button(e);
        break;
      case i.MESSENGER_CARD:
        this.messengerCard(e);
        break;
      case i.TABLE:
        this.table(e);
        break;
      case i.IF_ELSE_STATEMENT:
        this.ifElseStatement(e);
        break;
      case i.TWITTER_FOLLOW_BUTTON:
        this.twitterFollowButton(e);
        break;
      case i.FACEBOOK_LIKE_BUTTON:
        this.facebookLikeButton(e);
        break;
      case i.SOCIAL:
        this.social(e);
        break;
      case i.SPACER:
        this.spacer(e);
        break;
      case i.CALLOUT:
        this.callout(e);
        break;
      case i.COLLAPSIBLE_SECTION:
        this.collapsibleSection(e);
        break;
      case i.UNSUPPORTED_ELEMENT:
        this.unsupportedElement(e);
        break;
      default:
        this.handleFallback(e);
        break;
    }
  }
  /**
   * Creates a fallback node for block types whose schema node isn't registered.
   * Preserves the original block data for round-trip serialization.
   */
  handleFallback(e) {
    if (this.config.fallbackBlockConfig) {
      const { nodeTypeName: t } = this.config.fallbackBlockConfig, s = this.schema.nodes[t];
      s && (this.documentBuilder.openNode(s, {
        type: t,
        originalType: e.type,
        originalData: e
      }), this.documentBuilder.closeNode());
    }
  }
  table(e) {
    const t = this.schema.nodes.table;
    if (t) {
      let s = {
        // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
        responsive: e.responsive || !1,
        // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
        container: e.container || !1,
        sectionType: e.sectionType
      };
      typeof e.stacked == "boolean" && (s.stacked = e.stacked);
      const d = this.getPaddingAttrs(e);
      s = {
        ...s,
        backgroundColor: this.addBackgroundColor(e) ?? "",
        borderRadius: this.addBorderRadius(e) ?? "",
        ...d
      }, this.documentBuilder.openNode(t, s), e.rows.forEach((n) => this.tableRow(n, s)), this.documentBuilder.closeNode();
    } else
      this.handleFallback(e);
  }
  tableRow(e, t) {
    const s = this.schema.nodes.tableRow;
    if (s) {
      let d = t.responsive ? { responsiveClasses: l(e.cells.length) } : {};
      d = t.container ? { ...d, container: !0 } : d, this.documentBuilder.openNode(s, {}), e.cells.forEach((n) => this.tableCell(n, d)), this.documentBuilder.closeNode();
    }
  }
  tableCell(e, t) {
    const s = this.schema.nodes.tableCell;
    if (s) {
      if (t.container) {
        const d = this.getPaddingAttrs(e);
        t = {
          ...t,
          ...d
        };
      }
      !t.container && !t.responsive && (t = {
        ...t,
        backgroundColor: this.addBackgroundColor(e) ?? ""
      }), e.displayWidth && (t = {
        ...t,
        colwidth: [e.displayWidth]
      }), this.documentBuilder.openNode(s, t), t.container && e.content.length === 0 && this.schema.nodes.placeholder && this.placeholder(), e.content.forEach((d) => this.handle(d)), this.documentBuilder.closeNode();
    }
  }
  social(e) {
    const t = this.schema.nodes.social;
    t ? (this.documentBuilder.openNode(t, {
      alignment: this.alignmentClass(e),
      items: e.items
    }), this.documentBuilder.closeNode()) : this.handleFallback(e);
  }
  spacer(e) {
    const t = this.schema.nodes.spacer;
    t ? (this.documentBuilder.openNode(t, {
      height: e.height
    }), this.documentBuilder.closeNode()) : this.handleFallback(e);
  }
  callout(e) {
    const t = this.schema.nodes.callout;
    t ? (this.documentBuilder.openNode(t, {
      type: e.type,
      backgroundColor: this.addBackgroundColor(e) ?? "",
      borderColor: this.addBorderColor(e) ?? ""
    }), e.content.forEach((s) => this.handle(s)), this.documentBuilder.closeNode()) : this.handleFallback(e);
  }
  unsupportedElement(e) {
    const t = this.schema.nodes.unsupportedElement;
    t ? (this.documentBuilder.openNode(t, {
      type: e.type,
      unsupportedTypeName: e.unsupportedTypeName,
      text: e.text
    }), this.documentBuilder.closeNode()) : this.handleFallback(e);
  }
  placeholder(e = {}) {
    const t = this.schema.nodes.placeholder;
    t && (this.documentBuilder.openNode(t, e), this.documentBuilder.closeNode());
  }
  nestedList(e) {
    const t = this.schema.nodes[e.type];
    t ? (this.documentBuilder.openNode(t, {}), e.items.forEach((s) => this.nestedListItem(s)), this.documentBuilder.closeNode()) : this.handleFallback(e);
  }
  nestedListItem(e) {
    const t = this.schema.nodes.nestedListItem;
    t && (this.documentBuilder.openNode(t, {}), e.content.forEach((s) => this.handle(s)), this.documentBuilder.closeNode());
  }
  ifElseStatement(e) {
    const t = this.schema.nodes.ifElseStatement;
    t ? (this.documentBuilder.openNode(t, {
      predicatesBlocksPairs: e.predicatesBlocksPairs,
      fallbackBlocks: e.fallbackBlocks
    }), this.documentBuilder.closeNode()) : this.handleFallback(e);
  }
  twitterFollowButton(e) {
    const t = this.schema.nodes.twitterFollowButton;
    t ? (this.documentBuilder.openNode(t, {
      username: e.username
    }), this.documentBuilder.closeNode()) : this.handleFallback(e);
  }
  facebookLikeButton(e) {
    const t = this.schema.nodes.facebookLikeButton;
    t ? (this.documentBuilder.openNode(t, {
      url: e.url
    }), this.documentBuilder.closeNode()) : this.handleFallback(e);
  }
  image(e) {
    const t = this.schema.nodes.image;
    if (t) {
      const s = e.url, n = {
        // Use placeholder if URL is invalid, otherwise use the original URL
        src: s && typeof s == "string" && s.trim() !== "" ? s : this.config.images?.failedImageUrl ?? "",
        linkUrl: e.linkUrl,
        text: e.text,
        width: e.width,
        displayWidth: e.displayWidth,
        height: e.height,
        alignment: this.alignmentClass(e)
      };
      this.documentBuilder.openNode(t, n), this.documentBuilder.closeNode();
    } else
      this.handleFallback(e);
  }
  imageText(e) {
    const t = this.schema.nodes.imageText;
    t ? (this.documentBuilder.openNode(t, {
      imageUrl: e.imageUrl,
      title: "title" in e ? e.title : "",
      text: e.text
    }), this.documentBuilder.closeNode()) : this.handleFallback(e);
  }
  video(e) {
    const t = this.schema.nodes.video;
    if (t) {
      const s = "videoId" in e ? e.videoId : e.id;
      this.documentBuilder.openNode(t, {
        type: e.type,
        provider: e.provider,
        id: s
      }), this.documentBuilder.closeNode();
    } else
      this.handleFallback(e);
  }
  videoFile(e) {
    const t = this.schema.nodes.videoFile;
    t ? (this.documentBuilder.openNode(t, {
      type: e.type,
      thumbnailUrl: e.thumbnailUrl,
      url: e.url,
      captions: e.captions
    }), this.documentBuilder.closeNode()) : this.handleFallback(e);
  }
  audioFile(e) {
    const t = this.schema.nodes.audioFile;
    t ? (this.documentBuilder.openNode(t, {
      type: e.type,
      url: e.url
    }), this.documentBuilder.closeNode()) : this.handleFallback(e);
  }
  button(e) {
    const t = this.schema.nodes.button, s = this.unescapeExpression(e.text);
    if (t) {
      const d = this.getPaddingAttrs(e);
      this.documentBuilder.openNode(t, {
        type: e.type,
        linkUrl: e.linkUrl,
        buttonStyle: e.buttonStyle || "solid",
        alignment: this.alignmentClass(e),
        fontFamily: this.addFontFamily(e) ?? "",
        fontColor: this.addFontColor(e) ?? "",
        backgroundColor: this.addBackgroundColor(e) ?? "",
        ...d,
        borderRadius: this.addBorderRadius(e) ?? "",
        text: s
      }), this.documentBuilder.closeNode();
    } else
      this.handleFallback(e);
  }
  unescapeExpression(e) {
    const t = document.createElement("div");
    return t.innerHTML = r.sanitizeHtml(e), t.textContent || "";
  }
  horizontalRule(e) {
    const t = this.schema.nodes.horizontalRule;
    t ? (this.documentBuilder.openNode(t, {
      type: e.type,
      text: e?.text,
      width: e?.width ?? "",
      borderColor: this.addBorderColor(e) ?? "",
      borderWidth: this.addBorderWidth(e) ?? "",
      borderStyle: this.addBorderStyle(e) ?? ""
    }), this.documentBuilder.closeNode()) : this.handleFallback(e);
  }
  collapsibleSection(e) {
    const t = this.schema.nodes.collapsibleSection;
    if (!t) {
      this.handleFallback(e);
      return;
    }
    this.documentBuilder.openNode(t, {}), this.collapsibleSectionSummary(e), this.collapsibleSectionContent(e), this.documentBuilder.closeNode();
  }
  collapsibleSectionSummary(e) {
    const t = this.schema.nodes.collapsibleSectionSummary;
    t && (this.documentBuilder.openNode(t, {}), this.handle(e.summary), this.documentBuilder.closeNode());
  }
  collapsibleSectionContent(e) {
    const t = this.schema.nodes.collapsibleSectionContent;
    t && (this.documentBuilder.openNode(t, {}), e.content.forEach((s) => this.handle(s)), this.documentBuilder.closeNode());
  }
  html(e) {
    const t = this.schema.nodes.html;
    t ? (this.documentBuilder.openNode(t, { content: e.content }), this.documentBuilder.closeNode()) : this.handleFallback(e);
  }
  messengerCard(e) {
    const t = this.schema.nodes.messengerCard;
    t ? (this.documentBuilder.openNode(t, {
      canvas: e.canvas,
      text: e.text,
      messenger_app_id: e.messenger_app_id,
      uri: e.uri
    }), this.documentBuilder.closeNode()) : this.handleFallback(e);
  }
  alignmentClass(e) {
    return "align" in e ? e.align : a;
  }
  addFontFamily(e) {
    if ("style" in e)
      return e.style?.fontFamily;
  }
  addFontColor(e) {
    if ("style" in e)
      return e.style?.fontColor;
  }
  // TODO: interblocks.ts should export Stylable type
  addBackgroundColor(e) {
    if ("style" in e)
      return e.style?.backgroundColor;
  }
  addBorderColor(e) {
    if ("style" in e)
      return e.style?.borderColor;
  }
  addBorderStyle(e) {
    if ("style" in e)
      return e.style?.borderStyle;
  }
  addBorderWidth(e) {
    if ("style" in e)
      return e.style?.borderWidth;
  }
  getPaddingAttrs(e) {
    return "style" in e ? {
      paddingTop: e.style?.paddingTop ?? "",
      paddingBottom: e.style?.paddingBottom ?? "",
      paddingLeft: e.style?.paddingLeft ?? "",
      paddingRight: e.style?.paddingRight ?? ""
    } : {};
  }
  addBorderRadius(e) {
    if ("style" in e)
      return e.style?.borderRadius;
  }
}
export {
  B as BlockParser
};
